import React, {useEffect, useState} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import {isSmallerScreen} from "../../utils/deviceScreen";

const SMALLER_SCREEN_TITLE = "Screen size recommendation";
const SMALLER_SCREEN_MESSAGE =
    "Recommend using a laptop instead, since the application is primarily designed for larger screens. Alternatively, rotate your device to landscape mode for a better experience.";

const DISMISSED_SMALLER_SCREEN_DIALOG_KEY = "small-screen-recommendation-dismissed";

function hasDismissedSmallerScreenDialog(): boolean {
    return localStorage.getItem(DISMISSED_SMALLER_SCREEN_DIALOG_KEY) === "true";
}

function persistDismissedSmallerScreenDialog(): void {
    localStorage.setItem(DISMISSED_SMALLER_SCREEN_DIALOG_KEY, "true");
}

export const SmallScreenRecommendationDialog: React.FC = () => {
    const [smallerScreen, setSmallerScreen] = useState(isSmallerScreen);
    const [dismissedSmallerScreenDialog, setDismissedSmallerScreenDialog] = useState(hasDismissedSmallerScreenDialog);

    useEffect(() => {
        const updateSmallerScreen = () => {
            setSmallerScreen(isSmallerScreen());
        };

        window.addEventListener("resize", updateSmallerScreen);
        window.addEventListener("orientationchange", updateSmallerScreen);

        return () => {
            window.removeEventListener("resize", updateSmallerScreen);
            window.removeEventListener("orientationchange", updateSmallerScreen);
        };
    }, []);

    const open = smallerScreen && !dismissedSmallerScreenDialog;

    const handleClose = () => {
        persistDismissedSmallerScreenDialog();
        setDismissedSmallerScreenDialog(true);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="small-screen-recommendation-title"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="small-screen-recommendation-title" sx={{pb: 1}}>
                {SMALLER_SCREEN_TITLE}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{SMALLER_SCREEN_MESSAGE}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    Got it
                </Button>
            </DialogActions>
        </Dialog>
    );
};
